import {Subject} from 'rxjs';
import SupportItem from '../models/SupportItem';

export const addedSupportItemsSubject = new Subject<SupportItem[]>();
export const deletedSupportItemsSubject = new Subject<SupportItem[]>();
export const addedSupportItems$ = addedSupportItemsSubject.asObservable();
export const deletedSupportItems$ = deletedSupportItemsSubject.asObservable();
